@let engagement = engagement$ | async;
@let content = loadableContent$ | async;

@if (content.status === LoadableStatus.LOADING) {
  <mat-spinner class="align-self-center"></mat-spinner>
} @else if (content.status === LoadableStatus.LOADED) {
  <div>
    <img height="50" alt="Logo" [src]="customerAssetsUrl + 'email-header-logo.png'">
    <div class="d-flex align-items-center gap-6 py-6">
      <span>Partner: <b class="color-black">{{ engagement?.partnerName }}</b></span>
      <span>Start date: <b class="color-black">{{ engagement?.startDate }}</b></span>
    </div>
  </div>
  <div class="hub-box d-flex flex-column justify-content-center align-items-center bg-color-white shadow-sm">
    @let content = loadableContent$ | async;

    <div class="d-flex flex-column justify-content-start align-items-start w-100" @fadeInOut>
      <div class="hub-box-content-header w-100">
        @if (content.data?.successMessage) {
          <div class="alert alert--success" role="alert">
            {{ content.data.successMessage }}
          </div>
        }

        @if (content.data?.title) {
          <h2 [innerHTML]="content.data?.title | safeHtml"></h2>
        }

        <div class="d-flex flex-column justify-content-start align-items-start gap-2 py-6">
          @for (description of content.data?.descriptions; track description) {
            <p [innerHTML]="description | safeHtml"></p>
          }
        </div>
      </div>
    </div>

    <div class="hub-box-content-content w-100">
      @switch (content.data.view) {
        @case (EngagementLandingView.STEPS) {
          @let engagementSteps = content.data?.engagementSteps ?? [];
          <app-engagement-step-list [steps]="engagementSteps" (goToStep)="advance.emit($event)" />
        }
        @case (EngagementLandingView.REASSIGNMENT) {
          <app-engagement-reassignment-form #engagementReassignmentForm [engagementId]="engagement.id" />
        }
      }
    </div>

    <div class="hub-box-content-footer w-100">
      @if (content.data?.acknowledgement) {
        <p class="small-300 py-6">{{ content.data.acknowledgement }}</p>
      }

      @if (content.data?.buttons) {
        <div class="d-flex justify-content-between align-items-center gap-6">
          @for (button of content.data.buttons; track button) {
            @if (!button.hide) {
              <button
                class="d-flex align-items-center w-100"
                type="button"
                [color]="button.color ?? 'default'"
                [isLoading]="saving()"
                [dataSelector]="dataSelector + '-' + button.testId"
                (click)="button.onClick()"
                andButton
              >
                @if (button.icon) {
                  <aiwyn-icon [name]="button.icon" role="button"></aiwyn-icon>
                }
                <div class="ml-2">{{ button.label }}</div>
              </button>
            }
          }
        </div>
      }
    </div>
  </div>
}
